export function Logo({ compact = false }) {
  return (
    <a href="#top" data-testid="brand-logo" className="flex items-center gap-3 group">
      <svg width="40" height="40" viewBox="0 0 48 48" fill="none" aria-hidden="true">
        <path d="M10 40V10h12a9 9 0 0 1 5.4 16.2L36 40h-7l-7.5-12H16v12h-6Z" fill="none" stroke="#D4AF37" strokeWidth="2.2" />
        <path d="M16 22h6a3.5 3.5 0 0 0 0-7h-6v7Z" fill="#D4AF37" opacity="0.85" />
        <path d="M6 40h36" stroke="#D4AF37" strokeWidth="1.2" opacity="0.5" />
        <path d="M30 8a10 10 0 0 1 12 6" stroke="#F3E5AB" strokeWidth="1.2" opacity="0.7" fill="none" />
      </svg>
      {!compact && (
        <span className="leading-none">
          <span className="block font-serif-lux text-xl tracking-[0.28em] text-[#F5F5F0] group-hover:text-[#F3E5AB] transition-colors">RADIANCE</span>
          <span className="block text-[9px] tracking-[0.5em] text-[#D4AF37] mt-1">REALTORS</span>
        </span>
      )}
    </a>
  );
}
